import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'
import { getStorageItem } from '@/shared/lib/storage/localStorage'

const PROFILE_ENDPOINTS: Partial<Record<Roles, string>> = {
  [Roles.Trader]: '/v1/user/trader',
  [Roles.Merchant]: '/v1/user/merchant',
} as const

const getEndpoint = (): string => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  return userRole ? PROFILE_ENDPOINTS[userRole]! : PROFILE_ENDPOINTS[Roles.Trader]!
}

export const profileAPI = {
  get baseKey() {
    return getEndpoint()
  },
  get changePassword() {
    const endpoint = getEndpoint()
    return `${endpoint}/password`
  },
  get updateUser() {
    const endpoint = getEndpoint()
    return `${endpoint}/email`
  },
}
